import { render, staticRenderFns } from "./doc_viewer.vue?vue&type=template&id=17d5b9ce&scoped=true"
import script from "./doc_viewer.vue?vue&type=script&lang=js"
export * from "./doc_viewer.vue?vue&type=script&lang=js"
import style0 from "./doc_viewer.vue?vue&type=style&index=0&id=17d5b9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d5b9ce",
  null
  
)

export default component.exports